import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    console.log('Home page loaded');
  }, []);

  const handleModuleClick = (module) => {
    console.log('Module clicked:', module);
    switch(module) {
      case 'KAS':
        navigate('/kas/cardbit');
        break;
      case 'KEC':
        navigate('/kec');
        break;
      default:
        console.log(`${module} not implemented yet`);
    }
  };

  return (
    <div className="home-container">
      <div className="home-content">
        <h1>Welcome to TinyManager</h1>
        <p>Select a module from the sidebar to get started</p>
        <div className="home-modules">
          <div className="module-card" onClick={() => handleModuleClick('KAS')}>
            <h3>KAS</h3>
            <p>Card Bit Analysis Tool</p>
            <span className="module-status available">Available</span>
          </div>
          <div className="module-card disabled">
            <h3>INF</h3>
            <p>Information Module</p>
            <span className="module-status">Coming Soon</span>
          </div>
          <div className="module-card" onClick={() => handleModuleClick('KEC')}>
            <h3>KEC</h3>
            <p>Elevator Call API</p>
            <span className="module-status available">Available</span>
          </div>
          <div className="module-card disabled">
            <h3>KDS</h3>
            <p>KDS Module</p>
            <span className="module-status">Coming Soon</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;